import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Seo } from "@/components/site/Seo";
import { Reveal, Overline, Rule, Watermark } from "@/components/site/Primitives";
import { ConsultCTA } from "@/components/site/ConsultCTA";

const IMG =
  "https://images.unsplash.com/photo-1512403754473-27835f7b9984?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHxjaW5lbWF0aWMlMjBidXNpbmVzcyUyMHN0cmF0ZWd5JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MDM3MzUxMHww&ixlib=rb-4.1.0&q=85";

export default function Services() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/public/settings").then((r) => setS(r.data.services)).catch(() => {});
  }, []);

  return (
    <>
      <Seo title="Services" description="Strategic planning, business consulting, management and operational advisory, and risk and governance review." />

      <section className="relative flex min-h-[52vh] items-end overflow-hidden">
        <img src={IMG} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/20" />
        <div className="relative mx-auto w-full max-w-7xl px-5 pb-16 pt-28 lg:px-10">
          <Overline className="text-gold-400">What we do</Overline>
          <h1 className="mt-4 font-serif text-5xl font-light text-cream-100 lg:text-6xl">Services</h1>
        </div>
      </section>

      <section className="relative overflow-hidden">
        <Watermark className="-left-8 top-20 text-[18rem]">GF</Watermark>
        <div className="relative mx-auto max-w-4xl px-5 py-20 text-center lg:px-10">
          <p className="font-serif text-2xl font-light leading-relaxed text-steel-700">{s?.intro}</p>
          <Rule className="mx-auto mt-8" />
        </div>

        <div className="mx-auto max-w-6xl px-5 pb-20 lg:px-10">
          <div className="grid gap-px overflow-hidden border border-ink/10 bg-ink/10 md:grid-cols-2">
            {s?.items.map((it, i) => (
              <Reveal key={i} delay={i * 0.05} className="bg-cream-100 p-10">
                <span className="font-serif text-3xl text-gold-500">0{i + 1}</span>
                <h2 className="mt-4 font-serif text-3xl font-light text-ink">{it.title}</h2>
                <p className="mt-4 font-sans leading-relaxed text-steel-600">{it.body}</p>
              </Reveal>
            ))}
          </div>
          <p className="mx-auto mt-10 max-w-3xl text-center font-sans text-sm leading-relaxed text-steel-400">
            Descriptions are general in nature. Goldman Fischer does not provide securities brokerage, investment
            management or legal services through this website.
          </p>
        </div>
      </section>

      <ConsultCTA />
    </>
  );
}
